import { useRefs } from '../../context/RefContext'
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.scss'
import Swal from 'sweetalert2';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import companyLogo from '../../images/trimmed_logo.png'; // Placeholder for your actual logo image
const Contact = () =>
{
    useEffect(() =>
    {
        Aos.init({ duration: 1000, once: true, easing: 'ease-in-out' });
    }, [])
    const form = useRef();

const sendEmail = (e) => {
        e.preventDefault(); // Prevents the default form submission behavior (page reload)

        emailjs.sendForm(
            'service_id_placeholder',        // YOUR_SERVICE_ID (from EmailJS dashboard)
            'template_id_placeholder',       // YOUR_TEMPLATE_ID (from EmailJS dashboard)
            form.current,             // The form DOM element (obtained via useRef)
            'public_key_placeholder'        // YOUR_PUBLIC_KEY (from EmailJS dashboard)
        )
        .then((result) => {
            form.current.reset(); // Resets the form fields after successful submission
            Swal.fire({               // Displays a SweetAlert success message
                title: t`Mensaje Enviado`,
                text: t`¡Tu mensaje ha sido enviado con éxito!`,
                icon: 'success',
                confirmButtonText: 'OK',
                timer: 1500 // Disappears after 1.5 seconds
            });
        }, (error) => {
            console.log(error.text); // Logs error message to console
            Swal.fire({               // Displays a SweetAlert error message (you might want to add this)
                title: t`Error`,
                text: t`Hubo un error al enviar tu mensaje. Por favor, inténtalo de nuevo.`,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        });
    };
    const { contactRef } = useRefs()
        return (
    <div ref={contactRef} className='contact'>
        <div className="contact_container" data-aos='fade-up'>
            <h1 className="contact-main-title">
                <Trans>¡CONTACTANOS!</Trans>
            </h1>
            <div className='contact-content-row'>
                <div className="right">
                    <div className="text_container">
                        <img src={companyLogo} alt="Cosmic Shores Logo" />
                        
                        <div className="offices-grid">
                            <div className="office-block">
                                <span className="office-label"><Trans>Oficina Argentina</Trans></span>
                                <span className='open_sans'>
                                    Martín y Omar 224, Of. 7<br/>
                                    B1642 San Isidro, Buenos Aires,<br/>
                                    Argentina</span>
                            </div>

                            <div className="office-block">
                                <span className="office-label"><Trans>Oficina USA</Trans></span>
                                <span className='open_sans'>
                                    16969 NW 67th Ave, Suite 207<br/>
                                    Hialeah, FL 33015,<br/>
                                    USA
                                </span>
                            </div>
                        </div>

                        <p className='open_sans email-link'>
                            <a href="mailto:info@cosmic-shores.space">info@cosmic-shores.space</a>
                            </p>
                        <p className='open_sans email-link'>
                            <a href="https://www.cosmic-shores.space">www.cosmic-shores.space</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
}

export default Contact;
